import React from 'react';

import Autoplay from 'embla-carousel-autoplay';
import {Carousel, StyledGrid} from 'presentation/components';
import {CarrouselTypeEnum} from 'presentation/constants/carrouselTypeEnum';
import {useHostName} from 'presentation/hooks';
import {useMediaQueries} from 'presentation/pages/private/hooks';

import {ContentCollectionListEnum} from 'domain/usecases/private/content/post-content';
import {useContentQuery} from 'presentation/queries/useContentQuery';
import {translations} from 'presentation/translations-new';
import {chunkArray} from 'presentation/utils/chunckArray';
import {SectionContainer} from '../SectionContainer';
import {YouTubeBannerLoading} from './components/YouTubeBannerLoading';
import {StyledBox, StyledIcon, StyledImage, StyledLink} from './styles';
import {getItemsPerSlide} from './utils/formatSlides';
import {useFormattedBanners} from './hooks/useFormattedBanners';

const {lastVideos} = translations['pt-br'].privateFlow.home;

export function YouTubeBanners() {
	const {isMobile, isDesktop, isTablet, isLaptop} = useMediaQueries();

	const {
		dataHostNameState: {productCode},
	} = useHostName();

	const {
		data: banners,
		isError,
		isLoading,
	} = useContentQuery({
		lista_colection: [ContentCollectionListEnum.YOUTUBE],
		numero_item: 4,
		operadora: productCode[0].toString(),
	});

	const {formattedBanners, isProcessing, isEmpty, isSingleItem} = useFormattedBanners({
		banners,
		isDesktop,
		isLoading,
	});

	if (isError) {
		return null;
	}

	if (isLoading || isProcessing) {
		return <YouTubeBannerLoading />;
	}

	const productChunks = chunkArray(formattedBanners ?? [], getItemsPerSlide(isMobile, isTablet));

	return isEmpty ? null : (
		<SectionContainer
			title={lastVideos}
			titleMarginTop={0}
			titleMarginBottom={isLaptop ? 2 : '12px'}
			marginRight={isMobile ? '-16px' : undefined}
			showTitle>
			<StyledBox $isSingleItem={isSingleItem}>
				<Carousel
					hideButtons={isMobile}
					type={isTablet ? CarrouselTypeEnum.ARROWS_DOTS : CarrouselTypeEnum.DOTS}
					plugins={[Autoplay({delay: 5000, stopOnInteraction: false})]}
					options={{dragFree: false, containScroll: 'trimSnaps'}}
					isFullscreen
					slides={productChunks.map((chunk, index) => (
						<StyledGrid.Root key={index} spacing={2}>
							{chunk.map((banner, i) => (
								<StyledGrid.Item
									xs={12}
									sm={6}
									md={4}
									key={`${banner.imageAlt}-${i}`}>
									<StyledLink
										href={banner.link}
										target="_blank"
										rel="noreferrer noopener">
										<StyledIcon name="play-circle-filled" />
										<StyledImage src={banner.image} alt={banner.imageAlt} />
									</StyledLink>
								</StyledGrid.Item>
							))}
						</StyledGrid.Root>
					))}
				/>
			</StyledBox>
		</SectionContainer>
	);
}
